document.addEventListener('DOMContentLoaded', function() {
  initializeRechargeWidgets();
});

function initializeRechargeWidgets() {
  const widgets = document.querySelectorAll('.recharge-widget');
  if (!widgets.length) return;

  widgets.forEach(function(widget) {
    if (widget.dataset.initialized === 'true') {
      return;
    }
    widget.dataset.initialized = 'true';

    initializeWidget(widget);
  });
}

function initializeWidget(widget) {
  if (!widget) return;

  const variantOptionsEl = widget.querySelector('.recharge-widget__variant-options');
  let productVariants = [];

  if (variantOptionsEl && variantOptionsEl.dataset.productVariants) {
    try {
      productVariants = JSON.parse(variantOptionsEl.dataset.productVariants);
    } catch (e) {
    }
  }

  const selectedOptions = {};

  widget.querySelectorAll('.recharge-option-value__radio:checked').forEach(input => {
    const position = input.dataset.optionPosition;
    const value = input.value;
    selectedOptions[position] = value;
  });

  function updateVisualState() {
    widget.querySelectorAll('.recharge-option-value').forEach(label => {
      const input = label.querySelector('.recharge-option-value__radio');
      if (input && input.checked) {
        label.classList.add('is-selected');
      } else {
        label.classList.remove('is-selected');
      }
    });

    widget.querySelectorAll('.recharge-option').forEach(label => {
      const input = label.querySelector('.recharge-option__radio');
      if (input && input.checked) {
        label.classList.add('is-selected');
      } else {
        label.classList.remove('is-selected');
      }
    });
  }

  widget.querySelectorAll('.recharge-option__radio').forEach(option => {
    option.addEventListener('change', function() {
      const sellingPlanId = this.value;
      const hiddenInput = widget.querySelector('.recharge-widget__selected-plan');
      if (hiddenInput) {
        hiddenInput.value = sellingPlanId;
      }
      updateVisualState();
    });
  });

  widget.querySelectorAll('.recharge-option-value__radio').forEach(input => {
    input.addEventListener('change', function() {
      const position = this.dataset.optionPosition;
      const value = this.value;
      selectedOptions[position] = value;

      filterAvailableOptions();

      updateSelectedVariant();

      updateVisualState();
    });
  });

  function filterAvailableOptions() {
    widget.querySelectorAll('.recharge-option-group').forEach(group => {
      const position = group.dataset.optionPosition;

      group.querySelectorAll('.recharge-option-value').forEach(label => {
        const input = label.querySelector('.recharge-option-value__radio');
        const optionValue = input.value;

        const isAvailable = isOptionAvailable(position, optionValue);

        if (isAvailable) {
          label.classList.remove('is-unavailable');
          input.disabled = false;
        } else {
          label.classList.add('is-unavailable');
          input.disabled = true;
          if (input.checked) {
            input.checked = false;
            label.classList.remove('is-selected');
            delete selectedOptions[position];
          }
        }
      });

      const hasChecked = group.querySelector('.recharge-option-value__radio:checked');
      if (!hasChecked) {
        const firstAvailable = group.querySelector('.recharge-option-value:not(.is-unavailable) .recharge-option-value__radio');
        if (firstAvailable) {
          firstAvailable.checked = true;
          firstAvailable.closest('.recharge-option-value').classList.add('is-selected');
          selectedOptions[position] = firstAvailable.value;
        }
      }
    });
  }

  function isOptionAvailable(checkPosition, checkValue) {
    return productVariants.some(variant => {
      let matches = true;

      for (const [pos, val] of Object.entries(selectedOptions)) {
        if (pos === checkPosition) continue;
        if (variant[`option${pos}`] !== val) {
          matches = false;
          break;
        }
      }

      if (matches && variant[`option${checkPosition}`] === checkValue) {
        return true;
      }

      return false;
    });
  }

  function updateSelectedVariant() {
    const matchingVariant = productVariants.find(variant => {
      const isMatch = Object.entries(selectedOptions).every(([pos, val]) => {
        const variantOption = variant[`option${pos}`];
        return variantOption === val;
      });
      return isMatch;
    });

    if (matchingVariant) {
      widget.dataset.variantId = matchingVariant.id;
      updateVariantPrices();
      updateOneTimePrice(matchingVariant);
      updateSubscriptionPrices(matchingVariant);
    }
  }

  function updateVariantPrices() {
    widget.querySelectorAll('.recharge-option-group').forEach(group => {
      const position = group.dataset.optionPosition;

      group.querySelectorAll('.recharge-option-value').forEach(label => {
        const optionValue = label.dataset.optionValue;

        const testOptions = {...selectedOptions};
        testOptions[position] = optionValue;

        const matchedVariant = productVariants.find(variant => {
          return Object.entries(testOptions).every(([pos, val]) => {
            return variant[`option${pos}`] === val;
          });
        });

        if (matchedVariant) {
          const pricingDiv = label.querySelector('.recharge-option-value__pricing');
          if (pricingDiv) {
            if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
              pricingDiv.innerHTML = `
                <span class="recharge-option-value__price--compare">${formatMoney(matchedVariant.compare_at_price)}</span>
                <span class="recharge-option-value__price--sale">${formatMoney(matchedVariant.price)}</span>
              `;
            } else {
              pricingDiv.innerHTML = `<span class="recharge-option-value__price">${formatMoney(matchedVariant.price)}</span>`;
            }
          }
        }
      });
    });
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    const dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  function updateOneTimePrice(variant) {
    if (!variant) return;

    const oneTimeOption = widget.querySelector('.recharge-option[data-option-type="onetime"]');
    if (!oneTimeOption) return;

    const priceElement = oneTimeOption.querySelector('.recharge-option__price');
    if (priceElement) {
      priceElement.textContent = formatMoney(variant.price);
    }
  }

  function updateSubscriptionPrices(variant) {
    if (!variant) return;

    const subscriptionDiscount = 0.10;
    const basePrice = variant.price;
    const discountedPrice = Math.round(basePrice * (1 - subscriptionDiscount));

    widget.querySelectorAll('.recharge-option[data-option-type="subscription"]').forEach(option => {
      const pricingDiv = option.querySelector('.recharge-option__pricing');
      if (!pricingDiv) return;

      const priceElement = pricingDiv.querySelector('.recharge-option__price--sale') ||
                          pricingDiv.querySelector('.recharge-option__price');
      const comparePriceElement = pricingDiv.querySelector('.recharge-option__price--compare');

      if (priceElement) {
        priceElement.textContent = formatMoney(discountedPrice);
      }

      if (comparePriceElement) {
        comparePriceElement.textContent = formatMoney(basePrice);
      } else if (basePrice > discountedPrice) {
        pricingDiv.innerHTML = `
          <span class="recharge-option__price--sale">${formatMoney(discountedPrice)}</span>
          <span class="recharge-option__price--compare">${formatMoney(basePrice)}</span>
        `;
      } else {
        pricingDiv.innerHTML = `<span class="recharge-option__price">${formatMoney(discountedPrice)}</span>`;
      }
    });
  }

  filterAvailableOptions();
  updateSelectedVariant();
  updateVariantPrices();
  updateVisualState();

  widget.addEventListener('widget:show', function() {
    filterAvailableOptions();
    updateSelectedVariant();
    updateVariantPrices();
    updateVisualState();
  });
}

window.initializeRechargeWidgets = initializeRechargeWidgets;

